const routes = [
  {
    path: '/student/ChildCountCertificationHistory',
    component: () => import('@/views/student/ChildCountCertification/Wrapper'),
    children: [
      {
        path: '',
        name: 'ChildCountCertificationHistory',
        component: () =>
          import('@/views/student/ChildCountCertification/History.vue'),
      },
      {
        path: 'add',
        name: 'AddCertificationChildCount',
        component: () =>
          import(
            '@/views/student/ChildCountCertification/AddCertification.vue'
          ),
      },
      {
        path: '/student/ChildCountCertificationHistory/information',
        name: 'ChildCountInformation',
        component: () =>
          import(
            '@/views/student/ChildCountCertification/InformationCertification.vue'
          ),
      },
    ],
  },
];

export default routes;
